//= require_tree ./form-ui
require("./jquery.maskMoney");
require("./jquery.maskedinput");
require("./form-ui/conditional");
require("./form-ui/validation");
require("./form-ui/spinner");
require("./form-ui/files");

$("#email-sf").css({ opacity: "0", height: "0", "font-size": "0" });
